module.exports = "//cdn.mxpnl.com/static/asset-cache/96ea769d5b8073635c1a2bb77c9e7b2d/iron/common/widgets/demo-selector-modal/assets/icons/B2B.svg";